const configuration = {
    trace: true,
    name: 'onefront-frontend-home',
};

const devtools = () => window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__(configuration) : (f) => f;

export default devtools;
